import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { useMemo } from "react";
import moment from "moment";

const PatientsAgeChart = ({ ageData }) => {
  const categories = ageData?.categories || [];
  const data = ageData?.series?.[0]?.data || [];

  const options = {
    chart: {
      type: "column",
      backgroundColor: "#fff",
      borderRadius: 14,
      height: 125,
      width: 350,
      style: {
        fontFamily: "'Arial', sans-serif",
      },
    },
    title: {
      text: "",
      style: {
        fontSize: "14px",
        color: "#333",
      },
    },
    xAxis: {
      categories,
      labels: {
        style: {
          color: "#474747",
          fontSize: "10px",
        },
      },
      lineColor: "#333",
      tickColor: "#333",
    },
    yAxis: {
      title: {
        text: "",
      },
      labels: {
        style: {
          color: "#474747",
          fontSize: "10px",
        },
      },
      gridLineColor: "#fff",
    },
    series: [
      {
        name: "Patients",
        data: data,
        color: "#C3B9D8",
        borderRadius: 5,
      },
    ],
    tooltip: {
      shared: true,
      crosshairs: true,
      formatter: function () {
        return `${this.x}<br/>Patients: ${this.y}`;
      },
      backgroundColor: "rgba(255, 255, 255, 0.85)",
      borderColor: "#ccc",
      style: {
        color: "#333",
        fontSize: "12px",
      },
    },
    legend: {
      enabled: false,
    },
    credits: {
      enabled: false,
    },
  };

  return (
    <div className="p-4 w-99">
      <HighchartsReact highcharts={Highcharts} options={options} />
    </div>
  );
};

export default PatientsAgeChart;
